import { GetterTree, MutationTree, ActionTree } from "vuex/types/index";
import { Order } from "@foxone/api/src/models/defi";
import utils from "@/utils";

const state = () => ({
  orders: [],
  hasNext: true
});

export type OrdersState = ReturnType<
  () => {
    orders: Order[];
    hasNext: boolean;
  }
>;

const getters: GetterTree<OrdersState, {}> = {
  getGroupedOrders(state) {
    return state.orders.reduce((group, order) => {
      const date = utils.date.formatDate(
        +order.created_at * 1000,
        "YYYY/MM/DD"
      );
      if (!group[date]) {
        group[date] = [];
      }
      group[date].push(order);
      return group;
    }, {});
  }
};

const mutations: MutationTree<OrdersState> = {
  SET_ORDERS(state, data) {
    state.orders = data;
  },
  SET_HAS_NEXT(state, value) {
    state.hasNext = value;
  },
  REMOVE_ORDERS(state) {
    state.orders = [];
    state.hasNext = true;
  }
};

const actions: ActionTree<OrdersState, {}> = {
  async loadOrders({ commit, state }, { reload }) {
    // let offset = 0;
    // if (!reload) {
    //   offset = state.orders.length;
    // }
    // const orders = await this.$api.defi.getOrders({ limit: 10, offset });
    // if (reload) {
    //   commit("SET_ORDERS", orders);
    // } else {
    //   commit("SET_ORDERS", [...state.orders, ...orders]);
    // }
    // if (orders.length === 0) {
    //   commit("SET_HAS_NEXT", false);
    // }
  },
  removeOrders({ commit }) {
    commit("REMOVE_ORDERS");
    commit("SET_HAS_NEXT", true);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
